var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0007 13.8335C14.3688 13.8335 14.6673 14.132 14.6673 14.5002C14.6673 14.8684 14.3688 15.1668 14.0007 15.1668H2.00065C1.63246 15.1668 1.33398 14.8684 1.33398 14.5002C1.33398 14.132 1.63246 13.8335 2.00065 13.8335H14.0007ZM4.19591 9.36209L11.5292 2.02876C11.7696 1.78844 12.1477 1.76995 12.4093 1.9733L12.4721 2.02876L14.4721 4.02876C14.7124 4.26908 14.7309 4.64723 14.5275 4.90876L14.4721 4.97157L7.13872 12.3049C7.03454 12.4091 6.89941 12.4752 6.75495 12.4944L6.66732 12.5002H4.66732C4.32543 12.5002 4.04365 12.2428 4.00514 11.9112L4.00065 11.8335V9.8335C4.00065 9.68615 4.04943 9.54384 4.13804 9.42814L4.19591 9.36209L11.5292 2.02876L4.19591 9.36209ZM12.0007 3.44297L5.33398 10.1096V11.1668H6.39118L13.0578 4.50016L12.0007 3.44297Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/PenIcon.3e8b04c8.svg";
export { ForwardRef as ReactComponent };